import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { findClientById } from "../../poll/selectors";
import { Link } from "react-router-dom";
import { routes } from "../../router/router";

// The venue's name on a shift card, as a full-width button in the SEARCH
// button's colour. It goes where the name link went: the venue page with
// the notes. The phone number that used to follow the name is gone from
// the card on purpose - girls were calling the hotel instead of reading
// the notes (Nat, 12 Oct 2026).
class VenueNameButton extends React.Component {
	render() {
		return (
			<Link
				to={routes.Venue + "/" + this.props.clientId}
				className="btn btn-primary btn-block"
				style={{
					fontWeight: 600,
					fontSize: "15px",
					textAlign: "left",
					whiteSpace: "normal",
					marginBottom: "6px"
				}}
			>
				{this.props.client.ClientName}
				<span
					style={{
						display: "block",
						fontWeight: "normal",
						fontSize: "12px",
						opacity: 0.9
					}}
				>
					Click to read venue notes
				</span>
			</Link>
		);
	}
}

VenueNameButton.propTypes = {
	clientId: PropTypes.number.isRequired,
	client: PropTypes.object
};

const mapStateToProps = (state, props) => {
	return {
		client: findClientById(state, props.clientId)
	};
};

export default connect(mapStateToProps)(VenueNameButton);
